import Avatar from "@material-ui/core/Avatar";
import React, { useState } from "react";
import Call from "../../../assets/media/svg/icons/Communication/Call-light.svg";
import DropIcon from "../../../assets/media/svg/icons/General/Other2.svg";
import Update from "../../../assets/media/svg/icons/General/Update-light.svg";
import { fullNameFirstLetter } from "../helper/getFirstChartFromFullName";
import { displayStatus, statusBgColor, statusTextColor } from "./contstants";
import "./styles.scss";

const FeedCard = ({
	feedAvatar,
	changedBy,
	subtitle,
	description,
	color,
	status,
	date,
	firstName,
	lastName,
	onEventClick,
	onContactClick,
	suggestionText,
}) => {
	const displayStatusText = {
		note: `Updated by ${changedBy} on ${date}`,
		event: `Added by ${changedBy} on ${date}`,
		task: `Completed by ${changedBy} on ${date}`,
	};

	return (
		<div className="feed-card  w-100 mb-5">
			<div className="hover-border" />
			<div className="p-5">
				<div className=" w-100 d-flex align-items-center justify-content-between " style={{ paddingBottom: "13px" }}>
					<div className="d-flex">
						<Avatar className="mr-4" alt="img" src={feedAvatar}>
							{fullNameFirstLetter(firstName, lastName)?.toString()?.toUpperCase()}
						</Avatar>
						<div>
							<div className="cursor-pointer" onClick={onContactClick}>
								<h6 className="feed-title m-0 font-16">{`${firstName} ${lastName}`}</h6>
							</div>
							<div className="cursor-pointer" onClick={onEventClick}>
								<p className="feed-des" 
										style={{
											color: statusTextColor[status?.toLowerCase()],
										}}
								>
									{subtitle}
								</p>
							</div>
						</div>
					</div>
					<div className="d-flex h-100 justify-content-start">
						{status && (
							<div
								className="FeedStatusBagde"
								style={{
									background: statusBgColor[status?.toLowerCase()],
									color: statusTextColor[status?.toLowerCase()],
								}}
							>
								{displayStatus[status?.toLowerCase()]}
							</div>
						)}
					</div>
				</div>
				{description ? (
					<div>
						<p className="font-16" style={{ paddingBottom: "10px" }}>
							{description}
						</p>
					</div>
				) : null}
				<div className="pastoral__feeds__desc ">
					<p>{suggestionText}</p>
				</div>
				<div className="mt-4">
					<p 
						style={{ color: "#7B7B8B" }}
					>{displayStatusText[status?.toLowerCase()]}</p>
				</div>
			</div>
		</div>
	);
};

export default FeedCard;
